export default "__VITE_ASSET__BlJV8rfJ__"